import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Button } from '@material-ui/core'
import { templateSaveFormValidation } from '../../utils/validationSchema'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormTextField from '../FormTextField'
import FormRadioGroupField from '../FormRadioGroupField'

const TemplateSave = ({ onSubmit, cancelDialog, currentData, list }) => {
  const classes = formStyles()
  const formActions = useFormik({
    initialValues: {
      name: currentData?.name || '',
      privilegeId: currentData?.privilegeId?.toString() || ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    validationSchema: templateSaveFormValidation,
    onSubmit: ((values, formikHelpers) => {
      onSubmit({
        ...(!!list ? { ...currentData, ...values, simple: currentData?.simple || false } : values),
        privilegeId: parseInt(values.privilegeId)
      }, formikHelpers, null, currentData?.name)
    })
  })
  const privileges = [
    {
      key: '1',
      name: <FormattedMessage id='Fields.label.view.privilege.1'/>
    },
    {
      key: '2',
      name: <FormattedMessage id='Fields.label.view.privilege.2'/>
    }
  ]
  return (

    <form onSubmit={formActions.handleSubmit} noValidate autoComplete="off" className={classes.formWrapper}>

      <FormTextField name={'name'} labelKey={'Fields.label.view.templateName'} row required
                     classes={classes} formActions={formActions}/>

      <FormRadioGroupField name={'privilegeId'} labelKey={'Fields.label.view.privilege'} list={privileges}
                           classes={classes} formActions={formActions} required row/>

      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                onClick={formActions.handleSubmit}
                disabled={formActions.isSubmitting || !formActions.isValid}
        >
          <FormattedMessage id={`AddNewDialog.InvoiceActions.saveTemplate`}/>
        </Button>
        <Button variant='outlined' color='secondary'
                onClick={cancelDialog} className={'cancel'}>
          <FormattedMessage id='invoiceSteps.Cancel'/>
        </Button>
      </div>
      {!!formActions.isSubmitting && <FormLoader loading={true}/>}
    </form>
  )
}

export default TemplateSave
